import React, { useEffect, useState, useRef } from 'react';
 import { useThemeContext } from '../../fetchdata/ThemeContext';
import axiosInstance from '../../axiosInstance';
import messageAlertSound from '../../assets/audio/preview.mp3';
import { Link,useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
 import getDecryptData from '../../helpers/getDecryptData';
import SlideButton from "react-slide-button";

const Livebook = () => {
  
  const decryptdatajson = getDecryptData();

   const DriverId = decryptdatajson._id;

    const { AllBookReq,removeBook,  allRemoveId, setAllRemoveId,Headers ,getAuth,dataAuth} = useThemeContext();
    const [Loading, setLoading] = useState(true);
    const [Mybooking, setMybooking] = useState([]);
    const [FoundBook, setFoundBook] = useState(false);
    // const [allRemoveId, setAllRemoveId] = useState([]);
 

    useEffect(() => {

      console.log('Headers',Headers?.recommended_user)

        const fetchLiveBooks = async () => {
            if (Headers?.recommended_user  && AllBookReq && AllBookReq.length !== 0) {
       
if( Headers?.recommended_user.length !== 0){

    const updatedOrders = AllBookReq.filter(order => !allRemoveId.includes(order.orderId));
      const matchingOrders = updatedOrders.filter(order => Headers.recommended_user.includes(DriverId));

                 setMybooking(matchingOrders);
              // setMybooking(AllBookReq);
              console.log('AllBookReq',AllBookReq)
                setFoundBook(true);

             if(matchingOrders.length !== 0 ){
       const sound = new Audio(messageAlertSound);
              sound.play();
             } 

}else{
    const updatedOrders = AllBookReq.filter(order => !allRemoveId.includes(order.orderId));
                 setMybooking(updatedOrders);
              // setMybooking(AllBookReq);
              console.log('AllBookReq',AllBookReq)
                setFoundBook(true);

             if(updatedOrders.length !== 0 ){
       const sound = new Audio(messageAlertSound);
              sound.play();
             }

}
            
                // setLoading(true);
                // try {
                //     const response = await axiosInstance.get(`/get-all-Book/${DriverId}`);
                //     const { success, Bookings } = response.data;
                //     console.log('live data', Bookings);
                //     const reversedBookings = Bookings.reverse();

                //     setMybooking(Bookings);
                // } catch (error) {
                //     console.error('Error during login:', error);
                // } finally {
                //     setLoading(false);
                // }
            }
        };

        fetchLiveBooks();
        dataAuth();
    }, [AllBookReq,Headers]);

    const navigate = useNavigate();


    const AcceptBook = async (orderId) => {
 
      const driverId = decryptdatajson._id;
      const Bookdata = { orderId, driverId };
      try {
            const response = await axiosInstance.post('/accept-order',Bookdata);
            const { success  } = response.data;
            console.log('accept data', response);
       if(success){
        removeBook();
        navigate('/driver/Books');
    
       }
        } catch (error) {
            console.error('Error accept Order:', error);
            toast.error(error.response.data.message);
    
        }  
    
    }

        const [error, setError] = useState(null);
    
      const AcceptOrder = async (OrderId,id) => {
    

        if(getAuth.verified === 0){
toast.error('Please Complete KYC First');
navigate('/profile/edit')
return;
        }


           const decryptdatajson = await getDecryptData();
    
        let updatedFormData;
    
        updatedFormData = {
          OrderId,
          UserId: decryptdatajson._id,
        };
    
        console.log(updatedFormData);
    
        try { 
    
          await toast.promise(
            axiosInstance.post(`/admin/employee/accept-job`, updatedFormData),
            {
              loading: "Accept Job...", // Loading message
              success: "Accept Job successfully!", // Success message
              error: "Failed to Accept Job", // Error message
            }
          );
   
        //  navigate('/purchase/leads');
    
        } catch (error) {
          console.error("Error On Added Lead:", error);
           setError(error.response?.data?.message || "An unknown error occurred");
          toast.error(error.response.data.message);
         }finally{
          removeOrders(id)
         }
      };
    
    

    const CloseFoundBook = () => {
        console.log("close");
        setFoundBook(false);
        removeBook();
    };


    //  🧹 Remove all orders whose orderId is in allRemoveId
const removeOrders = (id) => {
  const updatedRemoveIds = [...allRemoveId, id]; // Add new id to the array
  setAllRemoveId(updatedRemoveIds); // Update state

  const updatedOrders = AllBookReq.filter(order => !updatedRemoveIds.includes(order.orderId));
  setMybooking(updatedOrders);
};

    return (
    <> 

 {(FoundBook && Mybooking.length !== 0) && (

<>
<div className='toast-wrap'>  
     <div
  className="toast fade show my-toast-Book bg-light"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
  data-bs-delay={3000}
  data-bs-autohide="false"
>
  <div className="toast-header "> 
  <i class="ri-suitcase-line text-primary fs-5"></i>
    <strong className="me-auto ms-2">New Job</strong>
    <small>1 min ago</small>
       <button
      className="btn btn-close position-relative p-1 shadow-none"
      type="button"
      onClick={CloseFoundBook} // Change onclick to onClick
      >
     <i class="close"></i>
    </button>
  </div>
  <div className="toast-body">

 
 <div className='m-0 overflow-y-scroll pe-1' style={{maxHeight:'60vh'}}>
 {Mybooking.map((booking, index) => (
          <div className="card p-3 mb-2" key={index}>
            <div className="d-flex m-0">
             
              <div className="media-body m-0">
                <h6 className="mt-2 mb-0">{booking.order?.details[0]?.username}</h6>
                <p className='small m-0 fw-light text-dark'>{booking.order?.details[0]?.address}</p>
                
              </div>
            </div>
            <p className='fw-bold small m-0' >  {booking.order?.items[0]?.date? new Date(booking.order?.items[0]?.date).toLocaleDateString('en-US', {
      weekday: 'short',
      day: '2-digit',
      month: 'short'
    }) : 'NA'} at {booking.order?.items[0]?.time} </p>
            <hr />
            <div className="d-flex justify-content-between align-items-center gap-2">
              <button type="button" className="btn btn-sm me-2 btn-danger" onClick={()=>{removeOrders(booking.order?.orderId)}}>
                Reject
              </button>


                   <SlideButton
                                      mainText={"Slide To Accept"}
                                      overlayText={"Loading..."}
                                      classList="my-class text-center startride m-0"
                                      caretClassList="my-caret-class"
                                      overlayClassList="my-overlay-class"
                                      onSlideDone={() => AcceptOrder(booking?.order?._id,booking.order?.orderId)}
                                      hasError={!!error} // Pass error state to SlideButton
                                    />

              {/* <button type="button" onClick={() => AcceptBook(booking._id)}className="btn btn-sm mb-2 me-2 btn-primary">
                Accept <i className="ri-arrow-right-line ms-2" />
              </button> */}
            </div>
          </div>
        ))}
 </div>

   
        <div className='text-center pt-3 border-top'>
        <Link className="btn btn-primary btn-sm m-auto" to="/driver/home" onClick={CloseFoundBook} // Change onclick to onClick
 > <i class="ri-route-fill me-1"></i> All Job</Link>
        </div>
 


  </div>
</div> 
</div>
</>

    )}

</>


  )
}

export default Livebook
